import { AuthenticationService } from './core.module';

export function appInitializer(authenticationService: AuthenticationService) {
    return () => new Promise(resolve => {
        // attempt to refresh token on app start up to auto authenticate
        authenticationService.refreshToken()
            .subscribe({
                next: () => resolve(true),
                error: () => resolve(true),
                complete: () => resolve(true)
            });
    });
}
